module.exports = __webpack_public_path__ + "static/media/img.b1389c77.jpg";